import { Pipe, PipeTransform } from '@angular/core';
import { DataFormatService } from 'src/app/core/services/data-format.service';

@Pipe({
  name: 'accountFormat'
})
export class AccountFormatPipe implements PipeTransform {

  transform(value: any, ...args: any): any {
    const dataFormat = new DataFormatService();
    if (!!value && args[0] === '000') {
      return dataFormat.formatAccountNumber(value);
    }
    return value;
  }

}
